import { openModal } from '3-components/Modal/Modal';
import { YOUTUBE_API_READY_EVENT } from '3-components/VideoEmbed/YoutubeAPI';

interface OpenModalSettings {
    id: string;
}

interface OpenModalProps {
    el: HTMLElement;
    props: OpenModalSettings
}

interface Player {
    // eslint-disable-next-line no-undef
    player: YT.Player | null;
    videoType: string | null;
    elementId: string;
}

const OpenModal = ({ el, props: { id } }: OpenModalProps) => {
    const modalEl = document.getElementById(id);

    if (!modalEl) return;
    const players: Player[] = [];

    // this function is fine right now to include with upload video checking because
    // this always available wether there's youtube video or not
    // if need to support vimeo this need to be refactored
    // considering need to wait for vimeo API to be available
    const onYoutubeAPIReady = () => {
        const playerEls = modalEl.querySelectorAll('iframe, video');

        playerEls.forEach((playerEl: Element) => {
            const videoType = playerEl.getAttribute('data-video-type');
            const elementId = playerEl.id;

            let player = null;
            if (videoType === 'youtube') {
                player = new window.YT.Player(elementId, {});
            }

            players.push({
                player,
                videoType,
                elementId
            });
        });
    };

    const pauseAllVideos = () => {
        players.forEach(({ player, videoType, elementId }) => {
            // console.log('players', player, videoType);
            if (videoType === 'youtube' && player) {
                player.pauseVideo();
            } else if (videoType === 'upload') {
                const videoEl = document.getElementById(elementId) as HTMLVideoElement || null;
                videoEl?.pause();
            }
        });
    };

    window.addEventListener(YOUTUBE_API_READY_EVENT, onYoutubeAPIReady);

    el.addEventListener('click', () => {
        openModal(id, {
            onClose: () => {
                pauseAllVideos();
                document.body.classList.remove('modal-opened');
            }
        });
    });
};

export default OpenModal;
